import React from 'react'

import { Bone } from 'components/layout'


type OrderItemSkeletonProps = {
  bgColor?: 'light-beige' | 'gray-20' | 'gray-70'
}

const OrderItemSkeleton: React.FunctionComponent<OrderItemSkeletonProps> = (props) => {
  const { bgColor = 'light-beige' } = props

  return (
    <Bone bgColor={bgColor} h={142} />
  )
}

export default OrderItemSkeleton
